import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useState } from 'react';
import DialogForm from 'src/components/quotations/DialogForm';
import RowsDetail from './RowsDetail';

type DataDialogType = {
  id: number;
  patientid: number;
  open: boolean;
};

type PaymentContentProps = {
  data: any;
};

const PaymentContent: React.FC<PaymentContentProps> = (props) => {
  const defaultDialog = {
    id: 0,
    patientid: 0,
    open: false,
  };
  const [dataDialogForm, setDataDialogForm] =
    useState<DataDialogType>(defaultDialog);

  const handleClickDelete = () => {};

  const handleClickForm = (patientid: number) => {
    setDataDialogForm({
      id: 0,
      patientid: patientid || 0,
      open: true,
    });
  };

  const handleCloseDialogForm = () => {
    setDataDialogForm(defaultDialog);
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table
          sx={{
            minWidth: 650,
            '& .MuiTableCell-root.MuiTableCell-head': {
              borderBottom: '1px solid #F3F3F3',
              fontWeight: 700,
              p: '6px 16px',
              fontSize: '14px',
            },
            '& .MuiTableCell-root.MuiTableCell-body': {
              color: 'primary.dark',
              fontSize: '14px',
              py: '10px',
            },
          }}
          aria-label='simple table'
        >
          <TableHead>
            <TableRow>
              <TableCell>患者ID</TableCell>
              <TableCell>患者名</TableCell>
              <TableCell>タイトル</TableCell>
              <TableCell>発行日</TableCell>
              <TableCell>実施日</TableCell>
              <TableCell>入金予定</TableCell>
              <TableCell>総額</TableCell>
              <TableCell>未納金額</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data.length > 0 &&
              props.data.map((item: any, index: number) => (
                <RowsDetail
                  item={item}
                  key={index}
                  handleEditClick={handleClickForm}
                />
              ))}
            {props.data.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={8}
                  sx={{ textAlign: 'center', verticalAlign: 'center' }}
                >
                  データがありません
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <DialogForm
        open={dataDialogForm.open}
        patientId={dataDialogForm.patientid}
        quoteId={dataDialogForm.id}
        onClose={handleCloseDialogForm}
        onDelete={handleClickDelete}
      />
    </>
  );
};

export default PaymentContent;
